// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__w1YfU","spinner":"style_spinner__tkgY8"};